export enum CourseType {
    TUTOR = 'TUTOR',
    CLASS = 'CLASS',
}

export const COURSE_TYPE_CONFIG = {
    [CourseType.TUTOR]: {
        label: 'Tutor',
        cssClass: 'text-sm !bg-purple-100 !text-purple-700'
    },
    [CourseType.CLASS]: {
        label: 'Lớp',
        cssClass: 'text-sm !bg-blue-100 !text-blue-700'
    }
};
